// extracted by mini-css-extract-plugin
export default {"toogle_group":"BtnTripTypes_toogle_group__JGNDt","type_checkbox":"BtnTripTypes_type_checkbox__voaPZ","error_msg":"BtnTripTypes_error_msg__impie"};